var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v(_vm._s(_vm.title)+" © "+_vm._s(_vm.year))]),_c('span',{on:{"click":function($event){_vm.delayUrlLoad('https://latishagriffiths.com/', 1000);
      return false;}}},[_c('i',{staticClass:"fas fa-link"})])])}
var staticRenderFns = []

export { render, staticRenderFns }